"use strict";

import "reflect-metadata";
import "zone.js/dist/zone";
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/map";
import "rxjs/add/observable/of";

import {main} from "./app";

main();



/** WEBPACK FOOTER **
 ** ./script/index.ts
 **/